<template>

    <Page>

        <Page class="!items-start">

            <h2 class="font-semibold text-xl">Our Proven Market-Ready Formula</h2>
            <p class="font-light text-white/80 italic mb-4 text-xl">
                We have a repeatable process for taking our core products and tailoring them for each market to ensure:
            </p>
            <ul class="font-normal text-white/80 list-disc pl-5 mb-6 text-xl">
                <li class="pl-3 mb-3 leading-tight"><span class="font-semibold text-cyan-400">Regulatory Approval</span> – structured to meet local laws and remain non-insurance.</li>
                <li class="pl-3 mb-3 leading-tight"><span class="font-semibold text-cyan-400">Financier Approval</span> – aligned with bank and captive finance requirements for easy integration.</li>
                <li class="pl-3 mb-3 leading-tight"><span class="font-semibold text-cyan-400">OEM Compatibility</span> – designed to complement, not conflict with, manufacturer programs.</li>
                <li class="pl-3 leading-tight"><span class="font-semibold text-cyan-400">Competitive Advantage</span> – priced strategically and positioned for a unique fit in the market.</li>
            </ul>

            <p class="font-light text-white italic text-2xl">
                This approach ensures every launch is compliant, partner-ready, and primed for rapid adoption.
            </p>
        </Page>

    </Page>

</template>